import { downloadFile, getIdOrNull } from '..'

const DEFAULT_PARAM_DOWNLOAD_INSTITUTION_DOCUMENT = { id: -1, originalName: '' }
export const downloadInstitutionDocument = (user, document = DEFAULT_PARAM_DOWNLOAD_INSTITUTION_DOCUMENT) => {
  return downloadFile(`/institution/document/download/${getIdOrNull(document)}`, document.originalName, user)
}
